module.exports = {"420624100":"城关镇","420624101":"武安镇","420624102":"九集镇","420624103":"李庙镇","420624104":"长坪镇","420624105":"薛坪镇","420624106":"板桥镇","420624107":"巡检镇","420624108":"东巩镇","420624109":"肖堰镇","420624500":"清河管理区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420624.json
// module id = 1864
// module chunks = 0